import { SALE_EXPERIMENTS } from '../constants/appConstants';

/**
 * returns true if the experiment is returned and sale price is shown to the user
 * @param experiment value from pricing api response
 * @returns
 */
export var showSaleBanner = function showSaleBanner(experiment) {
  return SALE_EXPERIMENTS.includes(experiment);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/utils/showSaleBanner.js
// module id = 4707
// module chunks = 11